import React from 'react'
import { getTagValue, getAttrValue, formatDateMDY } from 'helpers/Helpers';

export default function PublicRecords({publicrecords}) {
//console.log("publicrecords: ", publicrecords);

	return (
		<div className='w-full flex flex-col'>
			<div className='header-bar'>
				<div className='header-text'>Public Records</div>
			</div>
			<div>
				{ publicrecords &&
					publicrecords.map((pr, i) => {
						//console.log("pr: ", pr);
						return (
							<Record key={i} pr={pr} />
						)
					})
				}
				{ !publicrecords &&
						<div className='courier pl-4 font-semibold text-xl'> NO PUBLIC RECORDS</div>
				}
			</div>
		</div>
	)
}

function Record({pr}) {

	var cpr = pr;
	//console.log("cpr: ", cpr);


	const CourtName = getAttrValue(cpr, "_CourtName");
	const DateFiled = formatDateMDY(getAttrValue(cpr, "_FiledDate"));
	const ObligationType = getAttrValue(cpr, "_Type");
	const Disposition = getAttrValue(cpr, "_DispositionType");
	const DocketNumber = getAttrValue(cpr, "_DocketIdentifier");
	const DispositionDate = formatDateMDY(getAttrValue(cpr, "_PaidDate"));
	const Plaintiff = getAttrValue(cpr, "_PlaintiffName");
	const LiabilitiesAtBankruptcy = getAttrValue(cpr, "_BankruptcyLiabilitiesAmount");
	const AssetsAtBankruptcy = getAttrValue(cpr, "_BankruptcyAssetsAmount");
	const LiabilityAmount = getAttrValue(cpr, "_LegalObligationAmount");
	const Repositories = getAttrValue(cpr, "CreditPublicRecordID");
	const ObligationOwner = getAttrValue(cpr, "_PlaintiffName");

	return (
		<div className='grid grid-cols-[15%,40%,15%,30%] pl-2 pb-4 font-semibold'>

			<div>Court Name:</div>
			<div>{CourtName}</div>
			<div>Date Filed:</div>
			<div>{DateFiled}</div>

			<div>Obligation Type:</div>
			<div>{ObligationType}</div>
			<div>Disposition:</div>
			<div>{Disposition}</div>

			<div>Docket Number:</div>
			<div>{DocketNumber}</div>
			<div>Disposition Date:</div>
			<div>{DispositionDate}</div>

			{ Plaintiff > 0 &&
				<>
				<div>Plaintiff:</div>
				<div>{Plaintiff}</div>
				<div></div>
				<div></div>
			</>
			}

			{ LiabilitiesAtBankruptcy > 0 &&
			<>
				<div>Liabilities at Bankruptcy:</div>
				<div>{LiabilitiesAtBankruptcy}</div>
				<div></div>
				<div></div>
			</>
			}

			{ AssetsAtBankruptcy > 0 &&
			<>
				<div>Assets at Bankruptcy:</div>
				<div>{AssetsAtBankruptcy}</div>
				<div></div>
				<div></div>
			</>
			}

			<div>Liability Amount:</div>
			<div>{LiabilityAmount}</div>
			<div></div>
			<div></div>

			<div>Repositories:</div>
			<div>{Repositories}</div>
			<div>Obligation Owner:</div>
			<div>{ObligationOwner}</div>
		</div>
	)
}
